module.exports = __webpack_public_path__ + "src/routes/forgetpwd/true.png?ca044b64";


//////////////////
// WEBPACK FOOTER
// ./src/routes/forgetpwd/true.png
// module id = 2843
// module chunks = 1